export const usaHometabs = [
  "AI/ML",
  "AI Automation",
  "Chatbot & AI Agent",
  "Blockchain",
  // "Database",
  "Custom Software Development",
  "Mobile",
  // "DevOps",
  "Ecommerce",
];

export const usaHometabItems = [
  {
    tab: "AI/ML",
    icon: "/images/genai1.svg",
    name: "CycleGAN",
  },
  {
    tab: "AI/ML",
    icon: "/images/genai2.svg",
    name: "DeepArt",
  },
  {
    tab: "AI/ML",
    icon: "/images/genai3.svg",
    name: "DeepDream",
  },
  { tab: "AI/ML", icon: "/images/genai4.svg", name: "VQ-VAE" },
  { tab: "AI/ML", icon: "/images/genai5.svg", name: "GPT-4" },
  { tab: "AI/ML", icon: "/images/genai6.svg", name: "GPT-3" },
  { tab: "AI/ML", icon: "/images/genai6.svg", name: "DALL-E" },
  { tab: "AI/ML", icon: "/images/genai6.svg", name: "OpenAI GPT" },
  {
    tab: "AI/ML",
    icon: "/images/genai6.svg",
    name: "OpenAI DALL-E",
  },
  {
    tab: "AI/ML",
    icon: "/images/module1.svg",
    name: "DeepMind Sonnet",
  },
  {
    tab: "AI/ML",
    icon: "/images/module2.svg",
    name: "Facebook AI Research ",
  },
  {
    tab: "AI/ML",
    icon: "/images/module3.svg",
    name: "Hugging Face",
  },
  {
    tab: "AI/ML",
    icon: "/images/module4.svg",
    name: "NVIDIA StyleGAN",
  },
  {
    tab: "AI/ML",
    icon: "/images/tech-icon.svg",
    name: "PyTorch",
  },
  {
    tab: "AI/ML",
    icon: "/images/tech-icon2.svg",
    name: "Keras",
  },
  {
    tab: "AI/ML",
    icon: "/images/tech-icon3.svg",
    name: "MXNet",
  },
  {
    tab: "AI/ML",
    icon: "/images/tech-icon4.svg",
    name: "TensorFlow",
  },
  {
    tab: "AI/ML",
    icon: "/images/tech-icon5.svg",
    name: "Caffe",
  },
  { tab: "AI/ML", icon: "/images/natural1.svg", name: "RBM" },
  { tab: "AI/ML", icon: "/images/natural2.svg", name: "DBN" },
  {
    tab: "AI/ML",
    icon: "/images/natural7.svg",
    name: "Transformers",
  },
  {
    tab: "AI/ML",
    icon: "/images/natural4.svg",
    name: "Autoencoders",
  },
  { tab: "AI/ML", icon: "/images/natural5.svg", name: "DRLN" },
  { tab: "AI/ML", icon: "/images/natural6.svg", name: "GAN" },
  { tab: "AI/ML", icon: "/images/tech-icon.svg", name: "PyTorch" },
  { tab: "AI/ML", icon: "/images/tech-icon2.svg", name: "Keras" },
  { tab: "AI/ML", icon: "/images/tech-icon3.svg", name: "MXNet" },
  { tab: "AI/ML", icon: "/images/libraries1.svg", name: "FastAI" },
  { tab: "AI/ML", icon: "/images/libraries2.svg", name: "TensorFlow" },
  { tab: "AI/ML", icon: "/images/libraries3.svg", name: "Theano" },
  { tab: "AI/ML", icon: "/images/libraries4.svg", name: "Scikit-learn" },
  {
    tab: "AI/ML",
    icon: "/images/calsification.svg",
    name: "AlexNet",
  },
  {
    tab: "AI/ML",
    icon: "/images/calsification2.svg",
    name: "EfficientNet",
  },
  {
    tab: "AI/ML",
    icon: "/images/calsification3.svg",
    name: "Xception",
  },
  {
    tab: "AI/ML",
    icon: "/images/calsification4.svg",
    name: "DenseNet",
  },
  {
    tab: "AI/ML",
    icon: "/images/calsification5.svg",
    name: "Inception",
  },
  {
    tab: "AI/ML",
    icon: "/images/calsification6.svg",
    name: "ResNet",
  },
  {
    tab: "AI/ML",
    icon: "/images/calsification7.svg",
    name: "VGGNet",
  },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/langchain.png", name: "Langchain", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/airflow.png", name: "AirFlow", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/make-ai.png", name: "Make AI", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/n8n-automation.png", name: "N8n Automation", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/zapier.png", name: "Zapier", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/retail-ai.png", name: "Retail AI", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/vertex-ai.png", name: "Vertex", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/salinium.png", name: "Salinium", },
  { tab: "AI Automation", icon: "/images/tech-stack-icons/aws-steps.png", name: "aws-steps", },

  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/langchain.png", name: "Langchain", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/pinecone.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/weaviate.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/pinecone.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/chatgpt.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/rag.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/gemeni.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/lama.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/eleven-labs.png", name: "aws-steps", },
  { tab: "Chatbot & AI Agent", icon: "/images/tech-stack-icons/botpress.png", name: "aws-steps", },
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/ethereum.png",
    name: "Ethereum",
  },
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/stellar.png",
    name: "Stellar",
  },
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/Ripple.png",
    name: "Ripple",
  },

  // Enterprise Solutions
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/Hyperledger.png",
    name: "HyperLedger",
  },
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/microsoft-icon.png",
    name: "Azure Blockchain",
  },
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/download-3.png",
    name: "Azure Service Fabric",
  },

  // Consensus Mechanisms
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/tendermint-logo-black.png",
    name: "Tendermint",
  },

  // Storage Solutions
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/IPFS_logo.png",
    name: "IPFS",
  },
  {
    tab: "Blockchain",
    icon: "/images/tech-stack-icons/Bigchaindb.png",
    name: "BigChainDB",
  },
  { tab: "Custom Software Development", icon: "/images/iconone.png", name: "Angular JS" },
  { tab: "Custom Software Development", icon: "/images/icontwo.png", name: "JavaScript" },
  { tab: "Custom Software Development", icon: "/images/iconthree.png", name: "React JS" },
  { tab: "Custom Software Development", icon: "/images/icon4.png", name: "Vue JS" },
  { tab: "Custom Software Development", icon: "/images/icon5.png", name: "Tez JS" },
  { tab: "Custom Software Development", icon: "/images/icon6.png", name: "CSS3" },
  { tab: "Custom Software Development", icon: "/images/icon7.png", name: "HTML5" },
  { tab: "Custom Software Development", icon: "/images/database1.png", name: ".Net" },
  { tab: "Custom Software Development", icon: "/images/database2.png", name: "Nest Js" },
  { tab: "Custom Software Development", icon: "/images/database3.png", name: "Meteor JS" },
  { tab: "Custom Software Development", icon: "/images/database4.png", name: "Fastify" },
  { tab: "Custom Software Development", icon: "/images/database5.png", name: "Express JS" },
  { tab: "Custom Software Development", icon: "/images/database6.png", name: "Python" },
  { tab: "Custom Software Development", icon: "/images/database7.png", name: "Java" },
  { tab: "Custom Software Development", icon: "/images/database8.png", name: "PHP" },
  { tab: "Custom Software Development", icon: "/images/database9.png", name: "Node Js" },
  { tab: "Mobile", icon: "/images/mobile1.png", name: "Android" },
  { tab: "Mobile", icon: "/images/mobile2.png", name: "IOS" },
  { tab: "Mobile", icon: "/images/mobile3.png", name: "Swift" },
  { tab: "Mobile", icon: "/images/mobile4.png", name: "Flutter" },
  { tab: "Mobile", icon: "/images/mobile5.png", name: "Xamarin" },
  { tab: "Mobile", icon: "/images/mobile6.png", name: "React Native" },
  { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
  { tab: "Database", icon: "/images/db2.png", name: "Oracle " },
  { tab: "Database", icon: "/images/db3.png", name: "MongoDB" },
  {
    tab: "Database",
    icon: "/images/tech-stack-icons/postgres.svg",
    name: "PostgreSQL",
  },
  { tab: "Database", icon: "/images/db5.png", name: "MySQL" },
  { tab: "Database", icon: "/images/db6.png", name: "SQL Server" },
  { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
  { tab: "Database", icon: "/images/db8.png", name: "DynamoDB" },
  { tab: "Frameworks", icon: "/images/framework6.png", name: "Django" },
  { tab: "Frameworks", icon: "/images/framework2.png", name: "CodeIgniter" },
  { tab: "Frameworks", icon: "/images/framework3.png", name: "Laravel" },
  { tab: "Frameworks", icon: "/images/framework1.png", name: "MEAN" },
  { tab: "Frameworks", icon: "/images/framework4.png", name: "Rxweb.io" },
  { tab: "Frameworks", icon: "/images/framework5.png", name: "CakePHP" },
  { tab: "DevOps", icon: "/images/cloud1.png", name: "Google Cloud" },
  { tab: "DevOps", icon: "/images/cloud2.png", name: "Azure" },
  { tab: "DevOps", icon: "/images/cloud3.png", name: "AWS" },
  { tab: "DevOps", icon: "/images/DigitalOcean.png", name: "Digital Ocean" },
  { tab: "DevOps", icon: "/images/devops1.png", name: "Gradle" },
  { tab: "DevOps", icon: "/images/devops2.png", name: "Kubernetes" },
  { tab: "DevOps", icon: "/images/devops3.png", name: "Docker" },
  { tab: "DevOps", icon: "/images/devops4.png", name: "Jenkins" },
  {
    tab: "DevOps",
    icon: "/images/openshift-svgrepo-com.svg",
    name: "Open Shift",
  },
  { tab: "DevOps", icon: "/images/packer-svgrepo-com.svg", name: "Packer" },
  { tab: "DevOps", icon: "/images/ansible-svgrepo-com.svg", name: "Ansible" },
  {
    tab: "DevOps",
    icon: "/images/saltstack-svgrepo-com.svg",
    name: "Salt Stack",
  },
  { tab: "Ecommerce", icon: "/images/ecomres1.png", name: "NopCommerce" },
  { tab: "Ecommerce", icon: "/images/ecomres2.png", name: "Kentico" },
  { tab: "Ecommerce", icon: "/images/ecomres3.png", name: "Shopify" },
  { tab: "Ecommerce", icon: "/images/ecomres4.png", name: "Magento" },
  { tab: "Ecommerce", icon: "/images/ecomres5.png", name: "WooCommerce" },
  { tab: "Platforms", icon: "/images/platform1.png", name: "Servicenow " },
  { tab: "Platforms", icon: "/images/platform2.png", name: "Tableau" },
  {
    tab: "Platforms",
    icon: "/images/platform3.png",
    name: "MS Dynamics CRM",
  },
  { tab: "Platforms", icon: "/images/platform4.png", name: "Zoho" },
  { tab: "Platforms", icon: "/images/platform5.png", name: "Power BI" },
  { tab: "Platforms", icon: "/images/platform6.png", name: "Salesforce " },
];
